import { useEffect, useRef, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { setTimeoutResetCallback } from "./services/interceptor";
// import { setTimeoutResetCallback } from "../interceptor.js";

const AutoLogOut = () => {
  console.log("inside AutoLogOut");
  const { instance } = useMsal();
  const timeoutRef = useRef(null);
  const activeRequestsRef = useRef(0);

  const TIMEOUT_DURATION = (process.env.REACT_APP_SESSION_TIMEOUT_MINUTES || 15) * 60 * 1000;
  const clearCurrentTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  const logout = async () => {
    await instance.logoutRedirect();
    sessionStorage.clear();
  };

  const resetTimeout = () => {
    clearCurrentTimeout();
    if (activeRequestsRef.current === 0) {
      timeoutRef.current = setTimeout(logout, TIMEOUT_DURATION);
    }
  };

  const pauseTimeout = () => {
    activeRequestsRef.current++;
    clearCurrentTimeout();
  };

  const resumeTimeout = () => {
    activeRequestsRef.current = Math.max(0, activeRequestsRef.current - 1);
    if (activeRequestsRef.current === 0) {
      resetTimeout();
    }
  };



  useEffect(() => {
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'load'];

    events.forEach(event => {
      document.addEventListener(event, resetTimeout, true);
    });

    setTimeoutResetCallback({ resetTimeout, pauseTimeout, resumeTimeout });
    resetTimeout();

    return () => {
      events.forEach(event => {
        document.removeEventListener(event, resetTimeout, true);
      });
      setTimeoutResetCallback(null);
      clearCurrentTimeout();
    };
  }, []);
};

export default AutoLogOut;
